import React from 'react';

import { cn } from '../../lib/utils';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
    // data-testid comes before the spread so callers can still override it.
    return (
        <div data-testid='skeleton' className={cn('animate-pulse rounded-md bg-primary/10', className)} {...props} />
    );
}

export { Skeleton };
